<div class="view-container">

	<spreadsheet-lite [config]="form?.data ?? []" [previewMode]="true" (onCellSelected)="onCellSelected($event)"
		[selectedCellFormItem]="selectedFormItem"></spreadsheet-lite>
</div>